import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIAbstractProgress from 'UIComponents/progress/UIAbstractProgress';
import UINanoProgress from 'UIComponents/progress/UINanoProgress';
import UITable from 'UIComponents/table/UITable';
import { GOAL_TYPE } from '../../constants/goals';
import { useFetchAdSpendForGoalTarget } from '../../hooks/setupAdSpend';
import { COL_100, COL_50, TableLoadingBarContainer } from '../../utils/styles';
import AdSpendTableBody from './TableBody';
import AdsSpendTableHead from './TableHead';
export default function AdSpendTable({
  goalTarget,
  adCampaigns
}) {
  const {
    goalType
  } = goalTarget;
  const {
    adSpendPerCampaign,
    adSpendLoadingPercentage
  } = useFetchAdSpendForGoalTarget(goalTarget, adCampaigns);
  return /*#__PURE__*/_jsxs(TableLoadingBarContainer, {
    children: [/*#__PURE__*/_jsx(UIAbstractProgress, {
      incrementFactor: 0.15,
      autoStart: true,
      value: adSpendLoadingPercentage,
      render: ({
        value
      }) => /*#__PURE__*/_jsx(UINanoProgress, {
        value: value,
        animateOnComplete: true
      })
    }), /*#__PURE__*/_jsxs(UITable, {
      flush: true,
      children: [/*#__PURE__*/_jsxs("colgroup", {
        children: [/*#__PURE__*/_jsx(COL_50, {}), /*#__PURE__*/_jsx(COL_100, {}), /*#__PURE__*/_jsx(COL_100, {}), goalType !== GOAL_TYPE.COST_PER_CONTACT_IN_LIFECYCLE && /*#__PURE__*/_jsx(COL_100, {})]
      }), /*#__PURE__*/_jsx(AdsSpendTableHead, {
        goalTarget: goalTarget
      }), /*#__PURE__*/_jsx(AdSpendTableBody, {
        adSpendLoadingPercentage: adSpendLoadingPercentage,
        adSpendPerCampaign: adSpendPerCampaign,
        goalTarget: goalTarget,
        adCampaigns: adCampaigns
      })]
    }), /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "goals-reporting-lib.detailsPanel.adspend.dataInconsistencies"
      })
    })]
  });
}